import { useMatchMedia } from '@frontend/responsiveness';
import { SMALL_MODE_CALENDAR_VIEW_BREAKPOINT } from '../components/calendar-view/constants';

export const useIsScheduleSmallModeWindow = () => {
  const isSmallWindow = useMatchMedia({ maxWidth: SMALL_MODE_CALENDAR_VIEW_BREAKPOINT });

  return { isSmallModeWindow: isSmallWindow };
};
